export default "__VITE_ASSET__b548daea__"